import { Component, ElementRef, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AppService } from 'app/services/app/app.service';
import { RestService } from '../../services/rest/rest.service';
import { MatDialog } from '@angular/material/dialog';
import { MyWalletMovementsDialogComponent } from './my-wallet-movements-dialog.component';
import { MyWalletModel } from 'app/models/my-wallet-model';
import { CouponModel } from 'app/models/coupon-model';
import { DiscountModel } from 'app/models/discount-model';

@Component({
    selector: 'app-my-wallet',
    templateUrl: './my-wallet.component.html',
    styleUrls: ['./my-wallet.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MyWalletComponent implements OnInit {

  wallet:MyWalletModel = {
    id: 0,
    userId: 0,
    balance: 0,
    createdAt: 0,
    updatedAt: 0,
    lastMovement: {
      id: 0,
      walletId: 0,
      type: undefined,
      amount: 0,
      description: '',
      createdAt: 0,
      updatedAt: 0
    }
  }


  coupons: { [code: string]: CouponModel[] } = {};
  discounts: DiscountModel[] = [];


  constructor(
    private appService: AppService, 
    private restService: RestService, 
    private element : ElementRef,
    private dialog: MatDialog) { 

  }

  ngOnInit() {
    this.getMyWallet();
    this.getMyCoupons();
  }


  openInvoiceDialog() {
    this.dialog.open(MyWalletMovementsDialogComponent, {
      width: '650px',
      maxHeight: '90vh'
    });
  }



  getMyWallet(){
    this.restService.getMyWallet().subscribe((result:MyWalletModel) => {
      this.wallet = result;
    });
  }

  getMyCoupons(){
    this.restService.getMyCoupons().subscribe((result) => {
      this.discounts = result.discountsBought;

      result.couponsToBuy.forEach((coupon:CouponModel) => {
        const key = coupon.location.name; // O el parámetro que elijas
        if (!this.coupons[key]) {
          this.coupons[key] = [];
        }
        this.coupons[key].push(coupon);
      });

      console.log('coupons', this.coupons);
    });
  }


  buyMyDiscountCoupon(coupon:CouponModel){
    if (!confirm(this.appService.getTraduccion('myWallet.coupons.exchange.confirm'))) {
      return;
    }
    this.restService.buyMyDiscountCoupon(coupon.location.id, coupon.code).subscribe((result:MyWalletModel) => {
      this.getMyWallet();
      this.getMyCoupons();
    });
  }

  showDescriptionCoupons(key_: string){
    let key = 'myWallet.discount.' + key_;
    let t = this.appService.getTraduccion(key);
    if(t == key){
      return key_;
    }else{
      return t;
    }
  }

}
